import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import '../styles/Auth.css';

const Register = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authAPI.startRegistration(email);
      setEmailSent(true);
    } catch (err) {
      const errorData = err.response?.data;
      setError(errorData?.message || t('auth.emailSendError'));
    } finally {
      setLoading(false);
    }
  };

  const handleResendEmail = async () => {
    setResendLoading(true);
    setResendMessage('');

    try {
      await authAPI.startRegistration(email);
      setResendMessage(t('auth.newLinkSent'));
    } catch (err) {
      setResendMessage(err.response?.data?.message || t('auth.sendError'));
    } finally {
      setResendLoading(false);
    }
  };

  // Affichage après envoi de l'email
  if (emailSent) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>📧</div>
            <h2>{t('auth.checkEmail')}</h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              {t('auth.verificationSent')}<br />
              <strong>{email}</strong>
            </p>
            <p style={{ color: '#666', marginBottom: '30px' }}>
              {t('auth.clickLink')}
              <br />
              <small>{t('auth.linkExpires')}</small>
            </p>

            <div style={{ marginBottom: '20px' }}>
              <button
                onClick={handleResendEmail}
                className="btn-secondary"
                disabled={resendLoading}
              >
                {resendLoading ? t('common.sending') : t('auth.resendEmail')}
              </button>
            </div>

            {resendMessage && (
              <p style={{ color: resendMessage.includes('Erreur') ? '#e74c3c' : '#27ae60' }}>
                {resendMessage}
              </p>
            )}

            <p className="auth-link">
              <Link to="/login">{t('auth.backToLogin')}</Link>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{t('auth.registerTitle')}</h2>
        <p className="auth-subtitle">
          {t('auth.registerIntro')}
        </p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.emailLabel')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('auth.emailPlaceholder')}
              required
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? t('auth.sendingEmail') : t('auth.continue')}
          </button>
        </form>

        <p className="auth-link">
          <Link to="/login">{t('auth.alreadyAccount')}</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
